module.exports = __webpack_public_path__ + "static/media/Visa-Small.6c014ab7.png";